/**
 * Single source for status filters and dropdown options.
 * value: active | inactive, label: Active | Inactive.
 */
export const STATUS_LOWER = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export type StatusValue = (typeof STATUS_LOWER)[keyof typeof STATUS_LOWER];

/** Single source for status filters and dropdown options. */
export const STATUS_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: STATUS_LOWER.ACTIVE, label: 'Active' },
  { value: STATUS_LOWER.INACTIVE, label: 'Inactive' },
];

export const PLATFORM_TYPE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'marketplace', label: 'Marketplace' },
  { value: 'internal', label: 'Internal' },
  { value: 'social', label: 'Social' },
];
